import React, { useCallback } from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useRedirectOnCampaignChange } from '@occc-app/offerHelpers/hooks/useRedirectOnCampaignChange';
import { useGetProductGroupsForOffer } from '@occc-app/dataAccessLayer/productGroup/queries';

import { ConfigureForm } from './ConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { OfferConfigureFormInitialValues, OfferConfigureFormValues } from '../../types';

export const OfferConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const { offer } = props;
  const productGroups = useGetProductGroupsForOffer(offer);
  const transformOfferToInitialValuesWithProductGroups = useCallback(
    (currentOffer: Parameters<typeof transformOfferToInitialValues>[0]) =>
      transformOfferToInitialValues(currentOffer, productGroups),
    [productGroups],
  );

  const handleSubmitSuccess = useRedirectOnCampaignChange(props);

  const configureProps = useGetConfigureFormProps<
    OfferConfigureFormValues,
    OfferConfigureFormInitialValues
  >(props, transformOfferToInitialValuesWithProductGroups, getConfigureFormOperations, {
    onSubmitSuccess: handleSubmitSuccess,
  });

  return <ConfigureForm {...configureProps} />;
};
